import React from 'react';
import { KatBox } from '@amzn/katal-react';
import { StringGroup } from 'src/generated/graphql';
import { formatSourceReviewDateTime } from 'src/components/common/util/TimestampHelpers';
import { useTranslation } from 'src/i18next-arb-shim/useTranslation';

import styles from './MetadataBox.module.scss';

type Props = {
  stringGroup: StringGroup;
};

const MetadataBox: React.FC<Props> = (props: Props) => {
  const { i18n } = useTranslation();
  const formattedCxIds = props.stringGroup.cxIds?.join(', ');

  return (
    <KatBox variant="white" className={styles.messageGroupMetadataBox}>
      <div className={styles.metadataContainer}>
        <div className={styles.metadataItem}>
          <h5 title="CX Family">CX Family</h5>
          <p>{props.stringGroup.cxFamily}</p>
        </div>
        <div className={styles.metadataItem}>
          <h5 title="CX IDs">CX IDs</h5>
          <p>{formattedCxIds}</p>
        </div>
        <div className={styles.metadataItem}>
          <h5 title="Submitted on">Submitted on</h5>
          <p>
            {formatSourceReviewDateTime(
              props.stringGroup.sourceReviewRequestedTimestamp,
              true,
              i18n.language
            )}
          </p>
        </div>
        <div className={styles.metadataItem}>
          <h5 title="Submitted by">Submitted by</h5>
          <p>{props.stringGroup.sourceReviewRequester}</p>
        </div>
        <div className={styles.metadataItem}>
          <h5 title="Request ID">Request ID</h5>
          <p>{props.stringGroup.requestId}</p>
        </div>
      </div>
    </KatBox>
  );
};

export default MetadataBox;
